import { Component, Input, OnInit } from '@angular/core';
import { Result, TableAction, TableCode, TicketLogResult } from 'app/models';
import { TicketService } from 'app/services';

@Component({
  selector: 'app-ticket-history',
  templateUrl: './ticket-history.component.html',
  styleUrls: ['./ticket-history.component.scss']
})
export class TicketHistoryComponent implements OnInit {
  public result = new Result();
  public ticketLogs = new Array<TicketLogResult>();
  public tableCode = TableCode;
  public tableAction = TableAction;

  @Input()
  isBusy = false;

  @Input()
  public set id(value: number) {
    if (this.isBusy === false && value !== 0) {
      this.ticketLogs = new Array<TicketLogResult>();
      this.isBusy = true;
      this.ticketService.getTicketHistory(value).then(result => {
        this.isBusy = false;

        if (result.success === true) {
          this.ticketLogs = result.data;
        } else {
          this.result = result;
        }
      }).catch(() => {
        this.isBusy = false;
      });
    }
  }

  constructor(private ticketService: TicketService) { }

  ngOnInit(): void {
  }

}
